import eyeIcon from '../../../../assets/icons/eye.svg';

type ViewProfileRole = 'mentor' | 'student';

type ViewProfileButtonProps = {
  role: ViewProfileRole;
  slug: string;
  label: string;
  disabled?: boolean;
};

export function viewProfilePath(role: ViewProfileRole, slug: string): string {
  return `/${role}/read/${encodeURIComponent(slug)}`;
}

export function ViewProfileButton({
  role,
  slug,
  label,
  disabled = false,
}: ViewProfileButtonProps) {
  return (
    <button
      type="button"
      className="education-profile-page__preview-btn"
      disabled={disabled || !slug}
      onClick={() => {
        if (disabled || !slug) return;
        window.open(viewProfilePath(role, slug), '_blank', 'noopener,noreferrer');
      }}
    >
      <img src={eyeIcon} alt="" aria-hidden />
      {label}
    </button>
  );
}
